// LocatesNotFoundPopup.js
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import ReviewData from "../Components/ReviewData";
import { useSelector } from "react-redux";
import { selectSleeveDataStageOne } from "../../../Redux/Reducers/selectors";

const ReviewDataDialogue = ({ title, open, onClose }) => {
  const [existingNewArray, setExistingNewArray] = useState({});

  const sleeveDataStageOne = useSelector(selectSleeveDataStageOne);
  return (
    <Dialog
      fullWidth
      maxWidth={false}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "1000px",
          minHeight: "80vh",
          maxHeight: "95vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogTitle sx={{ flexShrink: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            align="left"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent sx={{ flex: "1 1 auto", overflow: "auto" }}>
        <ReviewData
          sleeve={true}
          setExistingNewArray={setExistingNewArray}
          existingNewArray={existingNewArray}
          sleeveDataStageOne={sleeveDataStageOne}
          showNext={false}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReviewDataDialogue;
